import { useDebounce } from '@shared/utils/hooks/useDebounce';
import { addAction } from '@shared/utils/logger';
import { useCardTelemetry } from '@apps/card/Card.telemetry';
import { useEffect } from 'react';

export function useSearchTermTelemetry(term: string) {
  // Debounce 3s to filter out the noise during typing.
  const debouncedTerm = useDebounce(term, 3000);
  const { buttonInteracted } = useCardTelemetry();

  useEffect(() => {
    if (!debouncedTerm) return;
    addAction('TermSearched', {
      term: debouncedTerm,
    });
    buttonInteracted({ name: 'designsGallery_termSearched', query: debouncedTerm });
  }, [debouncedTerm, buttonInteracted]);
}
